/**
 * Widget de discussion de tableinox.com.
 *
 * Aucune dépendance, aucun chargement externe, aucun traceur. L'historique vit
 * dans sessionStorage et disparaît à la fermeture de l'onglet.
 *
 * Le soin apporté au rythme n'est pas cosmétique. Une réponse instantanée se
 * lit comme une machine, et la personne cesse de formuler ses questions
 * sérieusement. Laura marque donc un temps de lecture, affiche qu'elle écrit,
 * puis répond en un temps proportionnel à la longueur de sa réponse. Elle
 * relance si elle a posé une question restée sans réponse, prend congé si le
 * silence dure, et demande une note à la fin.
 *
 * Intégration :
 *   <script src="{{ 'laura-chat.js' | asset_url }}" data-endpoint="https://tableinox-chat.workers.dev/chat"
 *           data-avatar="{{ 'laura-avatar.jpg' | asset_url }}" defer></script>
 */
(function () {
  "use strict";
  if (window.__chatTableinox) return;
  window.__chatTableinox = true;

  var S =
    document.currentScript ||
    (function () {
      var t = document.getElementsByTagName("script");
      return t[t.length - 1];
    })();

  var ENDPOINT = (S && S.getAttribute("data-endpoint")) || "/api/chat";
  var AVATAR = (S && S.getAttribute("data-avatar")) || "/images/laura.jpg";
  var CLE = "tableinox-chat";

  /* Rythme. Valeurs reprises du chatbot en service sur les autres sites du
     groupe, ou elles ont ete reglees a l'usage. */
  var LECTURE_MIN = 800;
  var LECTURE_ALEA = 700;
  var REPONSE_BASE = 5000;
  var REPONSE_PAR_CARACTERE = 22;
  var REPONSE_MAX_SUP = 5000;
  var RELANCE_MS = 45000;
  var CONGE_MS = 60000;

  var T = {
    nom: "Laura",
    statut: "Conseillère tableinox",
    ouvrir: "Ouvrir la discussion",
    fermer: "Fermer la discussion",
    saisie: "Écrivez votre question...",
    envoyer: "Envoyer",
    ecrit: "Laura écrit",
    accroche: "Une question ?",
    /* Volontairement neutre, sans prénom : Laura se présente elle-même dans sa
       première réponse. Une présentation affichée avant qu'elle ait parlé la
       forcerait à ne pas se nommer ensuite, et l'échange démarrerait sans que
       personne ne se soit présenté. */
    accueil:
      " 👋\n" +
      "Format, dosseret, délai, livraison : dites-moi ce qui vous amène.",
    suggestions: [
      "Quelle longueur pour mon poste ?",
      "Le dosseret sert à quoi ?",
      "Sous combien de temps je suis livré ?",
      "L'étagère basse est incluse ?",
    ],
    relance: "Avez-vous d'autres questions ?",
    conge: [
      "Merci de votre visite, je vous souhaite une bonne journée et à très vite 🙂",
      "Merci de votre visite, je vous souhaite une bonne soirée et à très vite 🙂",
    ],
    note: "Une dernière chose : quelle note donneriez-vous à cet échange ?",
    merci: "Merci beaucoup, cela nous aide 🙏",
    panne:
      "Je n'arrive pas à vous répondre à l'instant. Écrivez à contact@tableinox.com, l'équipe prend le relais.",
  };

  /* ---- Styles -------------------------------------------------------------
     Charte du site : degrade cyan vers bleu a 135 degres sur les surfaces
     pleines, bleu plein pour ce qui porte du texte. Le degrade de marque ne
     porte jamais de texte, son extremite cyan ne passe pas le contraste. */
  var CSS = [
    ".ti,.ti *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif}",

    /* Un cinquieme de moins qu'a l'origine : 56 px de haut devenus 45, visage
       de 40 devenu 32, libelle de 14 devenu 11.5. Le rayon ne suit pas la
       reduction, il reste a 10 px comme tous les coins du site. */
    ".ti-bulle{position:fixed;right:20px;bottom:20px;z-index:2147483000;height:45px;padding:0 14px 0 6px;border:0;border-radius:10px;cursor:pointer;background:linear-gradient(135deg,#333333 0%,#181818 100%);box-shadow:0 10px 26px -10px rgba(0,0,0,.35);display:flex;align-items:center;gap:8px;color:#fff;font-size:11.5px;font-weight:600;transition:transform .2s ease,box-shadow .2s ease}",
    ".ti-bulle.ti-rangee{display:none}",
    ".ti-bulle:hover{transform:translateY(-2px);box-shadow:0 16px 40px -10px rgba(0,0,0,.45)}",
    ".ti-bulle:focus-visible{outline:2px solid #181818;outline-offset:3px}",
    ".ti-bulle img{width:32px;height:32px;border-radius:50%;object-fit:cover;border:2px solid rgba(255,255,255,.9);display:block}",
    ".ti-vert{position:absolute;right:0;bottom:1px;width:11px;height:11px;border-radius:50%;background:#22c55e;border:2px solid #000000}",
    /* La pastille suit la bulle, pas l'en-tete du panneau, qui garde son
       visage de 42 px et sa pastille de 11. */
    ".ti-bulle .ti-vert{width:9px;height:9px}",

    ".ti-panneau{position:fixed;right:20px;bottom:20px;z-index:2147483001;width:min(392px,calc(100vw - 24px));height:min(540px,calc(100vh - 32px));border:1px solid transparent;border-radius:10px;background:linear-gradient(#fff,#fff) padding-box,linear-gradient(135deg,#4a4a4a 0%,#181818 100%) border-box;box-shadow:0 28px 70px -20px rgba(0,0,0,.4);display:none;flex-direction:column;overflow:hidden;opacity:0;transform:translateY(12px) scale(.98);transition:opacity .22s ease,transform .22s ease}",
    ".ti-panneau.ouvert{display:flex}",
    ".ti-panneau.visible{opacity:1;transform:none}",

    ".ti-tete{display:flex;align-items:center;gap:11px;padding:14px 16px;background:linear-gradient(135deg,#333333 0%,#181818 100%);color:#fff}",
    ".ti-av{width:42px;height:42px;border-radius:50%;object-fit:cover;border:2px solid rgba(255,255,255,.85);display:block}",
    ".ti-ident{position:relative;flex:0 0 auto;line-height:0}",
    ".ti-ident .ti-vert{border-color:#000000}",
    ".ti-nom{font-size:15px;font-weight:600;line-height:1.25}",
    ".ti-statut{font-size:12px;line-height:1.25;color:rgba(255,255,255,.78)}",
    ".ti-fermer{margin-left:auto;border:0;background:rgba(255,255,255,.14);cursor:pointer;padding:7px;border-radius:10px;color:#fff;line-height:0;transition:background .15s ease}",
    ".ti-fermer:hover{background:rgba(255,255,255,.26)}",

    ".ti-fil{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:9px;background:#fbfcfd}",
    ".ti-rang{display:flex;align-items:flex-end;gap:8px;max-width:88%}",
    ".ti-rang.moi{align-self:flex-end;flex-direction:row-reverse}",
    ".ti-rang.bot{align-self:flex-start}",
    ".ti-mini{width:26px;height:26px;border-radius:50%;object-fit:cover;flex:0 0 auto;margin-bottom:2px}",
    ".ti-msg{padding:11px 14px;border-radius:14px;font-size:14.5px;line-height:1.55;white-space:pre-wrap;word-wrap:break-word;animation:tiapparait .26s ease both}",
    ".ti-msg.bot{background:#fff;color:#111;border:1px solid #e7ecf0;border-bottom-left-radius:5px;box-shadow:0 1px 3px rgba(0,0,0,.04)}",
    ".ti-msg.moi{background:#181818;color:#fff;border-bottom-right-radius:5px}",
    ".ti-lien{color:#181818;font-weight:600;text-decoration:underline;text-underline-offset:2px}",
    ".ti-msg.moi .ti-lien{color:#fff}",
    "@keyframes tiapparait{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}",

    ".ti-sugg{display:flex;flex-wrap:wrap;gap:6px;align-self:flex-start;max-width:100%;margin-top:2px;padding-left:34px}",
    ".ti-sugg button{border:1px solid #e4e4e7;background:#fff;color:#000000;border-radius:10px;padding:8px 13px;font-size:12.5px;cursor:pointer;transition:background .15s ease,border-color .15s ease,transform .15s ease}",
    ".ti-sugg button:hover{background:#f4f4f5;border-color:#181818;transform:translateY(-1px)}",

    ".ti-typ{align-self:flex-start;display:flex;align-items:center;gap:7px;padding:10px 14px;background:#fff;border:1px solid #e7ecf0;border-radius:14px;border-bottom-left-radius:5px}",
    ".ti-typ i{width:6px;height:6px;border-radius:50%;background:#9aa3ab;animation:tibat 1.2s infinite}",
    ".ti-typ i:nth-child(2){animation-delay:.15s}.ti-typ i:nth-child(3){animation-delay:.3s}",
    ".ti-typ b{font-size:11.5px;font-weight:500;color:#7c868f;margin-left:3px}",
    "@keyframes tibat{0%,60%,100%{opacity:.28}30%{opacity:1}}",

    ".ti-notes{display:flex;gap:6px;width:100%}",
    ".ti-notes button{flex:1;border:1px solid #e4e4e7;background:#fff;border-radius:10px;padding:9px 0;font-size:14px;cursor:pointer;color:#000000;transition:background .15s ease}",
    ".ti-notes button:hover{background:#f4f4f5}",

    ".ti-bas{display:flex;gap:8px;padding:12px;border-top:1px solid #e7ecf0;background:#fff}",
    ".ti-champ{flex:1;border:1px solid #cfd6dc;border-radius:10px;padding:11px 13px;font-size:14px;color:#111;resize:none;max-height:100px;line-height:1.45}",
    ".ti-champ:focus{outline:2px solid #181818;outline-offset:-1px;border-color:#181818}",
    ".ti-envoyer{border:0;border-radius:10px;width:44px;display:grid;place-items:center;cursor:pointer;background:linear-gradient(135deg,#333333 0%,#181818 100%);color:#fff;transition:opacity .15s ease}",
    ".ti-envoyer:disabled{opacity:.45;cursor:default}",

    /* Sous 1024 px, la bulle disparait : la barre d'action fixe du bas porte
       deja l'acces a Laura, a cote du bouton d'inscription. Deux entrees pour
       la meme conversation dans le meme coin d'ecran, dont l'une recouvrait
       l'autre, ne valaient pas mieux qu'une. */
    "@media (max-width:1023px){.ti-bulle{display:none}}",
    "@media (max-width:480px){.ti-panneau{right:8px;left:8px;bottom:8px;width:auto;height:min(78vh,600px)}}",
    /* Un champ de moins de 16 px fait agrandir la page par Safari iOS des le
       premier appui, et rien ne la reduit ensuite : le visiteur tape sa
       question dans une page qu'il doit pincer pour relire. Le widget porte sa
       propre feuille de style, hors de celle du site : la regle equivalente de
       `globals.css` ne l'atteint pas, celle-ci portant une classe. */
    "@media (pointer:coarse) and (max-width:1023px){.ti-champ{font-size:16px}}",
    "@media (prefers-reduced-motion:reduce){.ti-bulle,.ti-msg,.ti-panneau,.ti-typ i{transition:none;animation:none}}",
  ].join("");

  var IC_CROIX =
    '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var IC_ENVOI =
    '<svg width="17" height="17" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3 10l14-6-6 14-2.2-5.8L3 10z" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  function lire() {
    try {
      return JSON.parse(sessionStorage.getItem(CLE) || "[]");
    } catch {
      return [];
    }
  }
  function ecrire(h) {
    try {
      sessionStorage.setItem(CLE, JSON.stringify(h.slice(-24)));
    } catch {
      /* navigation privee : on continue sans persistance */
    }
  }

  /** Bonjour ou bonsoir selon l'heure de la personne, pas la notre. */
  function salut() {
    var h = new Date().getHours();
    return h >= 18 || h < 5 ? "Bonsoir" : "Bonjour";
  }
  function conge() {
    var h = new Date().getHours();
    return h >= 18 || h < 5 ? T.conge[1] : T.conge[0];
  }

  /* Le tunnel d'inscription charge la discussion mais masque la bulle : posee en
     bas a droite, elle recouvre le bouton de paiement, la ou le doigt va
     justement cliquer. L'acces passe alors par le bouton de l'en-tete, qui
     appelle ouvrirChatTableinox. */
  var SANS_BULLE = S && S.hasAttribute("data-sans-bulle");

  var style = document.createElement("style");
  style.textContent = CSS + (SANS_BULLE ? ".ti-bulle{display:none}" : "");
  document.head.appendChild(style);

  var racine = document.createElement("div");
  racine.className = "ti";
  racine.innerHTML =
    '<button class="ti-bulle" type="button" aria-label="' +
    T.ouvrir +
    '"><span style="position:relative;display:block"><img src="' + AVATAR + '" alt="" width="40" height="40"><span class="ti-vert"></span></span><span>' +
    T.accroche +
    "</span></button>" +
    '<section class="ti-panneau" role="dialog" aria-label="Discussion avec ' +
    T.nom +
    '">' +
    '<header class="ti-tete">' +
    '<span class="ti-ident"><img class="ti-av" src="' + AVATAR + '" alt="" width="42" height="42"><span class="ti-vert"></span></span>' +
    '<span><span class="ti-nom">' +
    T.nom +
    '</span><br><span class="ti-statut">' +
    T.statut +
    "</span></span>" +
    '<button class="ti-fermer" type="button" aria-label="' +
    T.fermer +
    '">' +
    IC_CROIX +
    "</button></header>" +
    '<div class="ti-fil" role="log" aria-live="polite"></div>' +
    '<div class="ti-bas"><textarea class="ti-champ" rows="1" placeholder="' +
    T.saisie +
    '" aria-label="' +
    T.saisie +
    '"></textarea>' +
    '<button class="ti-envoyer" type="button" aria-label="' +
    T.envoyer +
    '">' +
    IC_ENVOI +
    "</button></div></section>";
  document.body.appendChild(racine);

  var bulle = racine.querySelector(".ti-bulle");
  var panneau = racine.querySelector(".ti-panneau");
  var fil = racine.querySelector(".ti-fil");
  var champ = racine.querySelector(".ti-champ");
  var bouton = racine.querySelector(".ti-envoyer");

  var occupe = false;
  var congePris = false;
  var tRelance = null;
  var tConge = null;

  function ajouter(texte, qui) {
    var rang = document.createElement("div");
    rang.className = "ti-rang " + qui;
    if (qui === "bot") {
      var av = document.createElement("img");
      av.className = "ti-mini";
      av.src = AVATAR;
      av.alt = "";
      rang.appendChild(av);
    }
    var msg = document.createElement("div");
    msg.className = "ti-msg " + qui;
    poserTexte(msg, texte);
    rang.appendChild(msg);
    fil.appendChild(rang);
    fil.scrollTop = fil.scrollHeight;
  }

  /**
   * Ecrit le texte d'un message en rendant cliquables les adresses du site.
   *
   * Construit en noeuds DOM, jamais en innerHTML : le texte vient d'un modele
   * de langage, l'inserer comme du HTML ouvrirait une injection. Seules les
   * adresses de ce site deviennent des liens, et elles s'ouvrent dans le meme
   * onglet : la personne garde sa conversation, la page change derriere.
   */
  function poserTexte(hote, texte) {
    var motif = /(https?:\/\/[^\s<>"')]+|(?:^|[\s(])\/[a-z0-9][a-z0-9\-/]*)/gi;
    var reste = String(texte);
    var position = 0;
    var trouve;
    motif.lastIndex = 0;
    while ((trouve = motif.exec(reste)) !== null) {
      var brut = trouve[0];
      var decalage = brut.length - brut.replace(/^[s(]/, "").length;
      var adresse = brut.slice(decalage);
      var debut = trouve.index + decalage;
      var propre = adresse.replace(/[.,;:!?)]+$/, "");
      var interne = propre.charAt(0) === "/";
      if (!interne) {
        try {
          interne = new URL(propre).host === location.host;
        } catch {
          interne = false;
        }
      }
      if (!interne) continue;
      if (debut > position) hote.appendChild(document.createTextNode(reste.slice(position, debut)));
      var lien = document.createElement("a");
      lien.href = propre;
      lien.textContent = propre.replace(/^https?:\/\/[^/]+/, "") || propre;
      lien.className = "ti-lien";
      hote.appendChild(lien);
      position = debut + propre.length;
    }
    if (position < reste.length) hote.appendChild(document.createTextNode(reste.slice(position)));
  }

  var indicateur = null;
  function frappe(actif) {
    if (actif) {
      if (indicateur) return;
      indicateur = document.createElement("div");
      indicateur.className = "ti-typ";
      indicateur.setAttribute("aria-label", T.ecrit);
      indicateur.innerHTML = "<i></i><i></i><i></i><b>" + T.ecrit + "</b>";
      fil.appendChild(indicateur);
      fil.scrollTop = fil.scrollHeight;
    } else if (indicateur) {
      indicateur.remove();
      indicateur = null;
    }
  }

  /* Les propositions vivent dans le fil, collees au message qui les motive.
     Placees sous le fil, elles etaient repoussees en bas du panneau par la
     hauteur elastique, et un vide s'ouvrait entre l'accueil et elles. */
  function retirerPropositions() {
    var vieilles = fil.querySelectorAll(".ti-sugg, .ti-notes");
    for (var i = 0; i < vieilles.length; i++) vieilles[i].remove();
  }

  function afficherSuggestions() {
    retirerPropositions();
    if (lire().length || congePris) return;
    var boite = document.createElement("div");
    boite.className = "ti-sugg";
    T.suggestions.forEach(function (question) {
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = question;
      b.addEventListener("click", function () {
        retirerPropositions();
        envoyer(question);
      });
      boite.appendChild(b);
    });
    fil.appendChild(boite);
    fil.scrollTop = fil.scrollHeight;
  }

  function rendre() {
    fil.innerHTML = "";
    var h = lire();
    if (!h.length) {
      ajouter(salut() + T.accueil, "bot");
    } else {
      h.forEach(function (m) {
        ajouter(m.content, m.role === "user" ? "moi" : "bot");
      });
    }
    afficherSuggestions();
  }

  /* La bulle se range par une classe, jamais par un style en ligne. Ecrit en
     ligne, `display:flex` a la fermeture ressuscitait la bulle sur telephone :
     il l'emportait sur la regle de media qui l'y masque, et l'ancien bouton du
     coin revenait par-dessus la barre d'action. Une classe laisse la feuille de
     style decider, donc la largeur de l'ecran. */
  function basculer(ouvrir) {
    if (ouvrir) {
      panneau.classList.add("ouvert");
      bulle.classList.add("ti-rangee");
      rendre();
      requestAnimationFrame(function () {
        panneau.classList.add("visible");
      });
      setTimeout(function () {
        /* preventScroll : le champ vit dans un panneau fixe, mais lui donner le
           focus fait quand meme defiler le document, qui remonte en haut. On
           refermait la discussion pour se retrouver au debut de la page, loin
           de l'endroit qu'on lisait. */
        champ.focus({ preventScroll: true });
      }, 220);
    } else {
      panneau.classList.remove("visible");
      setTimeout(function () {
        panneau.classList.remove("ouvert");
        bulle.classList.remove("ti-rangee");
      }, 200);
    }
  }

  bulle.addEventListener("click", function () {
    basculer(true);
  });

  /* Ouverture depuis la page elle-meme : la bulle du coin n'est pas le seul
     acces. Le bouton de l'en-tete et celui de la page contact appellent cette
     fonction, et ouvrent donc cette conversation-la, pas une autre.
     Posee sur window, elle reste joignable par un composant rendu apres ce
     script, qui est charge en fin de peinture. */
  window.ouvrirChatTableinox = function () {
    basculer(true);
  };
  racine.querySelector(".ti-fermer").addEventListener("click", function () {
    basculer(false);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && panneau.classList.contains("ouvert")) basculer(false);
  });

  champ.addEventListener("input", function () {
    champ.style.height = "auto";
    champ.style.height = Math.min(champ.scrollHeight, 100) + "px";
  });
  champ.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      envoyer(champ.value);
    }
  });
  bouton.addEventListener("click", function () {
    envoyer(champ.value);
  });

  function annulerRelance() {
    if (tRelance) clearTimeout(tRelance);
    if (tConge) clearTimeout(tConge);
    tRelance = null;
    tConge = null;
  }

  /** Message pousse par Laura sans que la personne ait ecrit. */
  function pousser(texte) {
    ajouter(texte, "bot");
    var h = lire();
    h.push({ role: "assistant", content: texte });
    ecrire(h);
  }

  /**
   * Relance, puis conge. Ne se declenche que si Laura a termine sur une
   * question : relancer quelqu'un a qui on n'a rien demande est intrusif.
   */
  function planifierRelance(reponse) {
    annulerRelance();
    if (congePris || !/\?\s*$/.test(reponse.trim())) return;
    tRelance = setTimeout(function () {
      pousser(T.relance);
      tConge = setTimeout(function () {
        congePris = true;
        pousser(conge());
        setTimeout(demanderNote, 1400);
      }, CONGE_MS);
    }, RELANCE_MS);
  }

  function demanderNote() {
    if (fil.querySelector(".ti-notes")) return;
    ajouter(T.note, "bot");
    var boite = document.createElement("div");
    boite.className = "ti-notes";
    for (var n = 1; n <= 5; n++) {
      (function () {
        var b = document.createElement("button");
        b.type = "button";
        b.textContent = String(n);
        b.addEventListener("click", function () {
          boite.remove();
          ajouter(T.merci, "bot");
        });
        boite.appendChild(b);
      })();
    }
    retirerPropositions();
    fil.appendChild(boite);
    fil.scrollTop = fil.scrollHeight;
  }

  function envoyer(texte) {
    texte = (texte || "").trim();
    if (!texte || occupe) return;
    occupe = true;
    bouton.disabled = true;
    champ.value = "";
    champ.style.height = "auto";
    retirerPropositions();
    annulerRelance();

    var h = lire();
    h.push({ role: "user", content: texte });
    ecrire(h);
    ajouter(texte, "moi");

    /* Temps de lecture avant que l'indicateur apparaisse, avec un peu
       d'aleatoire : un delai constant se repere en deux echanges. */
    var depart = Date.now();
    var lecture = LECTURE_MIN + Math.round(Math.random() * LECTURE_ALEA);
    setTimeout(function () {
      if (occupe) frappe(true);
    }, lecture);

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: h, page: location.pathname }),
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return { reponse: T.panne };
      })
      .then(function (d) {
        var reponse = (d && d.reponse) || T.panne;
        /* Duree totale voulue depuis l'envoi, proportionnelle a la longueur :
           la personne doit voir Laura ecrire, sans attendre pour rien. */
        var total = REPONSE_BASE + Math.min(reponse.length * REPONSE_PAR_CARACTERE, REPONSE_MAX_SUP);
        setTimeout(
          function () {
            frappe(false);
            ajouter(reponse, "bot");
            var courant = lire();
            courant.push({ role: "assistant", content: reponse });
            ecrire(courant);
            occupe = false;
            bouton.disabled = false;
            champ.focus();
            planifierRelance(reponse);
          },
          Math.max(0, total - (Date.now() - depart)),
        );
      });
  }
})();
